import { render } from "./SectionLayout.vue?vue&type=template&id=9974c4ec"
import script from "./SectionLayout.vue?vue&type=script&lang=js"
export * from "./SectionLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__